import React, { useEffect, useState } from "react";

import { JOB_TYPES } from "components/job/type/constants";
import { JobTypeDisplayCard } from "components/job/type/display-card";
import { Separator } from "ui/components/separator";
import { SheetDescription } from "ui/components/sheet";

const JobTypeInput = ({ value, onChange }) => {
  const [selectedType, setSelectedType] = useState(null);

  const selectedJobType = JOB_TYPES[selectedType];

  useEffect(() => {
    if (value) {
      setSelectedType(value);
    }
  }, [value]);

  function handleTypeSelection(jobType) {
    setSelectedType(jobType.id);
    onChange?.(jobType.id);
  }

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        {Object.values(JOB_TYPES).map((jobType) => (
          <JobTypeDisplayCard
            {...jobType}
            key={jobType.id}
            isSelected={selectedType === jobType.id}
            onClick={() => handleTypeSelection(jobType)}
          />
        ))}
      </div>
      {selectedJobType && (
        <>
          <Separator className="my-7" />
          <SheetDescription>
            <h3 className="font-semibold text-neutral-900 mb-2">
              {selectedJobType.title}
            </h3>
            <p className="text-sm ">{selectedJobType.description}</p>
          </SheetDescription>
        </>
      )}
    </div>
  );
};

export default JobTypeInput;
